import domReady from "@wordpress/dom-ready";
import { pauseVideo } from "./modalVideo";

domReady(() => {
	// CLOSE MODAL
	const closeHandler = () => {
		jQuery(".modal-wrapper.show").fadeOut(500, "easeInOutCirc");
		document.querySelector("body").classList.remove("no-scroll");
		if (window.player) pauseVideo(window.videoType);
	};
	const btnClose = document.querySelectorAll(".modal-close");
	const overlayClose = document.querySelectorAll(".modal-wrapper .overlay");

	btnClose.forEach((item) =>
		item.addEventListener("click", closeHandler, true)
	);
	overlayClose.forEach((item) =>
		item.addEventListener("click", closeHandler, true)
	);
});
